<app-step2-simple [discount]="discount()" [isCasual]="isCasual()" hideDatePart [isRequestMaterial]="true" [completeUrl]="completeUrl()"></app-step2-simple>
